<template>
  <div
    class="v-steps"
    :class="[
       !simple && 'v-steps--' + direction,
       simple && 'v-steps--simple'
     ]">
      <slot></slot>
  </div>
</template>

<script>
import Migrating from '../mixins/migrating';
export default {
  name: 'v-steps',
  mixins: [Migrating],
  props: {
    space: [Number, String],
    lineSpace: {
        type: Number,
        default: 12
    },
    active: Number,
    size: {
        type: [Number],
        default: 64
    },
    iconSize: {
        type: [Number],
        default: 24
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    alignCenter: {
        type: Boolean,
        default: true
    },
    simple: Boolean,
    finishStatus: {
      type: String,
      default: 'success'
    },
    processStatus: {
      type: String,
      default: 'process'
    },
    headerAlign: {
        type: String,
        default: 'top' // top normal
    }
  },
  data() {
    return {
      steps: [],
      stepOffset: 0
    };
  },
  methods: {
    getMigratingConfig() {
      return {
        props: {
          'center': 'center is removed.'
        }
      };
    }
  },
  watch: {
    active(newVal, oldVal) {
      this.$emit('change', newVal, oldVal);
    },
    steps(steps) {
      steps.forEach((child, index) => {
        child.index = index;
      });
    }
  }
};
</script>

<style lang="less" scoped>

.v-steps {
    display: flex
}

.v-steps--simple {
    padding: 13px 8%;
    border-radius: 4px;
    background: #f5f7fa
}

.v-steps--horizontal {
    white-space: nowrap
}

.v-steps--vertical {
    height: 100%;
    flex-flow: column
}
</style>


// WEBPACK FOOTER //
// src/components/framework/steps/steps.vue